import React from 'react';
import { Reference } from 'types/reference';
import { useAccount } from 'frontastic';
import RegisterForm from './register-form';
import AlterForm from '../../account/account-atoms/alter-form';

export interface RegisterProps {
  termsOfUseLink?: Reference;
}

const Register: React.FC<RegisterProps> = ({ termsOfUseLink }) => {
  const { loggedIn } = useAccount();

  return (
    <>
      <div className="m-auto grid px-16 md:max-w-[720px]">
        <RegisterForm termsOfUseLink={termsOfUseLink} />
      </div>
      {!loggedIn && <AlterForm page="login" />}
    </>
  );
};

export default Register;
